import { Component, inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-js-accept-dialog',
  templateUrl: './js-accept-dialog.component.html',
  styleUrls: ['./js-accept-dialog.component.scss'],
  standalone: false
})
export class JsAcceptDialogComponent implements OnInit {

  protected title: string;

  protected data = inject(NZ_MODAL_DATA) as { side: string };

  constructor(
    private dialogRef: NzModalRef<JsAcceptDialogComponent>
  ) { }

  public ngOnInit(): void {
    this.title = this.data.side === 'ssp'
      ? 'We recommend you to work via JS tags with trusted partners only (preferably direct publishers).'
      : 'We recommend you to work via JS tags with your partners based on your numbers and tend to set strict caps.';
  }

  protected onCancel(): void {
    this.dialogRef.close({ action: 'cancel' });
  }

  protected onAccept(): void {
    this.dialogRef.close({ action: 'accept' });
  }

}
